import { Injectable } from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {EntityContainerModel} from '../../../../../../models/aggregates/erp/entity';
import {Core2Config} from '../../shared/core2Config';
import {HttpClient} from '@angular/common/http';
import { LoginEntityUpdateRequestDtoModel } from '../../../data-transfer-objects';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { BasicApiResponseModel } from '../../shared';


@Injectable({
    providedIn: 'root'
  })
  export class CustomerEntityLoginService extends BaseApiTemplateService<EntityContainerModel> {
  
    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/customers/login-entity-ep';
  
    constructor(http: HttpClient) {
      super();
      this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/customers/login-entity-ep';
      this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/customers/login-entity-ep';
      this.httpClient = http;
    }

    public updateCustomerEntity(dtoObject: LoginEntityUpdateRequestDtoModel, visa: ApiVisa): Observable<BasicApiResponseModel<EntityContainerModel>> {
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
      }
      return this.httpClient.put<BasicApiResponseModel<EntityContainerModel>>(
        this.apiUrl,
        dtoObject,
        this.getHttpHeader(visa)
      );
    }
}